import { render, staticRenderFns } from "./tbbzj.vue?vue&type=template&id=6b475c8a&scoped=true"
import script from "./tbbzj.vue?vue&type=script&lang=js"
export * from "./tbbzj.vue?vue&type=script&lang=js"
import style0 from "./tbbzj.vue?vue&type=style&index=0&id=6b475c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b475c8a",
  null
  
)

export default component.exports